function parseElementHtml(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.body.firstChild;
}


function toggleBodyClass(className, isApplyingClass) {
  const classList = document.body.classList;
  if (isApplyingClass === true) {
    classList.add(className);
  } else {
    classList.remove(className);
  }
}

export {
  parseElementHtml,
  toggleBodyClass,
};



// WEBPACK FOOTER //
// ./src/syos/utils/html.js